import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import {
  deactivateChangeSensorStateMode,
  restoreActionInfo,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
  saveActionStateDescription,
  saveActionType,
} from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectBrightnessValue
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/MezzoActions/MezzoLightsActions/SelectBrightnessValue/SelectBrightnessValue'
import SelectBrightnessValueIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/MezzoActions/MezzoLightsActions/SelectBrightnessValue/SelectBrightnessValue'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectBrightnessValueIOS) : withStyles(SelectBrightnessValue)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const {
    isChangeActionStateMode, isChangeActionMode, isChangeSensorStateMode, isEditActionMode, initialAction,
  } = state.scenes.currentSceneCreating
  const { actions } = state.scenes.currentSceneConditionsActions
  return {
    isMobile,
    path,
    isChangeActionStateMode,
    isChangeActionMode,
    isChangeSensorStateMode,
    isEditActionMode,
    actions,
    initialAction,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveActionStateDescription,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
  saveActionType,
  deactivateChangeSensorStateMode,
  restoreActionInfo,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectBrightnessValueEnhanced = enhance

export default withRouter(SelectBrightnessValueEnhanced)
